// antd v5 static APIs (Modal.confirm, message, notification) render nothing
// on React 19 without this patch; it must be the first import (KAN-163).
import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';
import './styles/print.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './auth/AuthContext';
import { DisplaySettingsProvider } from './theme/DisplaySettingsContext';
import { ThemedConfigProvider } from './theme/ThemedConfigProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <DisplaySettingsProvider>
      <ThemedConfigProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemedConfigProvider>
    </DisplaySettingsProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
